import React, { Component } from 'react';
import { Form } from 'react-bootstrap';
import { SERVER_URL } from './ServerConfig';

export default class Login extends Component {
    constructor(props) {
        super(props);

        let rememberMeString = localStorage.getItem('rememberMe');
        let rememberMe = {
            shouldRemember : false,
            email : '',
            password : '',
        };
        if (rememberMeString) {
            rememberMe = JSON.parse(rememberMeString);
        }

        this.state = {
            email: rememberMe.email,
            password: rememberMe.password,
            loginContent: {},
            validated: false,
            message: '',
            shouldRemember : rememberMe.shouldRemember
        };
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleRememberMeChange = this.handleRememberMeChange.bind(this);
    }

    handleEmailChange(event) {
        this.setState({ email: event.target.value });
    }

    handlePasswordChange(event) {
        this.setState({ password: event.target.value });
    }

    handleSubmit(event) {
        event.preventDefault();
        if (!this.state.email || !this.state.password) {
            this.setState({ validated: true });
            return;
        }
        fetch(SERVER_URL + '/v1/users/login', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                email: this.state.email,
                password: this.state.password
            })
        }).then(response => response.json())
            .then(data => {
                if (!data) {
                    return;
                }
                if (data.success) {
                    this.saveRememberMe();
                    this.props.changePayload(data.content);
                    this.fetchStation(data.content);
                } else {
                    this.setState({ message: data.message });
                }
            }).catch(err => {
                this.setState({ message: "Server is in maintenance" });
            });
    }

    fetchStation(payload) {
        let token = payload.token;
        let project = payload.user.member.mProjectID;
        fetch(SERVER_URL + '/v1/projects/' + project._id + '/getStations', {
            headers: {
                'x-access-token': token
            }
        })
            .then(response => {
                if (response.status === 403) {
                    this.props.history.push("/login");
                } else {
                    return response.json();
                }
            })
            .then(data => {
                let stations = data.content;
                if (stations.length > 0) {
                    this.props.history.push( "/dashboard?station=" + stations[0]._id);
                } else {
                    this.props.history.push( "/dashboard");
                }
                
            })
    }

    handleRememberMeChange(event) {
        this.setState({ shouldRemember : !this.state.shouldRemember });
    }

    saveRememberMe() {
        let rememberMe = {
            shouldRemember : false,
            email : '',
            password : '',
        };
        if (this.state.shouldRemember) {
            rememberMe = {
                shouldRemember : true,
                email : this.state.email,
                password : this.state.password,
            }
        }

        localStorage.setItem('rememberMe', JSON.stringify(rememberMe));
    }

    render() {
        return (
            <div className="hold-transition login-page">
                <div className="bg-image" />
                <div className="reset-box">
                    <div className="login-logo logo">

                    </div>
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-center">
                                <h2><b>Solar </b>Monitoring</h2>
                            </div>
                            <p className="login-box-msg mt-2">Sign in to start your session</p>
                            <div className="text-center">
                                <p className="text-danger">{this.state.message}</p>
                            </div>
                            <Form onSubmit={this.handleSubmit} validated={this.state.validated}>
                                <Form.Row>
                                    <Form.Group controlId="validationCustom01" className="input-group mb-3">
                                        <Form.Control
                                            required
                                            type="text"
                                            placeholder="Username"
                                            value={this.state.email}
                                            onChange={this.handleEmailChange}
                                        />
                                        <div className="input-group-append">
                                            <div className="input-group-text">
                                                <span className="fas fa-user-circle"></span>
                                            </div>
                                        </div>
                                        <Form.Control.Feedback type="invalid">Email cannot be empty</Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group controlId="validationCustom02" className="input-group mb-3">
                                        <Form.Control
                                            required
                                            type="password"
                                            placeholder="Password"
                                            value={this.state.password}
                                            onChange={this.handlePasswordChange}
                                        />
                                        <div className="input-group-append">
                                            <div className="input-group-text">
                                                <span className="fas fa-lock"></span>
                                            </div>
                                        </div>
                                        <Form.Control.Feedback type="invalid">Password cannot be empty</Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                                <div className="row">
                                    <div className="col-8">
                                        <div className="icheck-primary">
                                            <input type="checkbox" id="remember" defaultChecked={this.state.shouldRemember} onClick={this.handleRememberMeChange}/>
                                            <label htmlFor="remember">Remember Me</label>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <button type="submit" className="btn btn-primary btn-block">Sign In</button>
                                    </div>
                                </div>
                            </Form>
                            {/* <p className="mt-2 mb-1">
                                <a href="forgot-password">I forgot my password</a>
                            </p> */}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}